const Rating = [
	'Très important',
	'Assez important',
	'Peu important',
	'Pas du tout important'
]

export default Rating



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/Rating.js